import * as React from 'react';
import {Fragment} from 'react';
import Toolbar from '@mui/material/Toolbar';

import {SaveButton, ToolbarProps, useNotify, useRecordContext, useRedirect,} from 'react-admin';
import {Billing} from '../types';

const BillingEditToolbar = (props: ToolbarProps) => {
    const {resource} = props;
    const redirect = useRedirect();
    const notify = useNotify();

    const record = useRecordContext<Billing>(props);

    if (!record) return null;
    return (
        <Toolbar
            sx={{
                backgroundColor: 'background.paper',
                display: 'flex',
                justifyContent: 'space-between',
                minHeight: {sm: 0},
            }}
        >
            <Fragment>
                <SaveButton
                    label="resources.businesses.fields.save"
                    mutationOptions={{
                        onSuccess: () => {
                            notify('ra.notification.updated', {
                                type: 'info',
                                messageArgs: {smart_count: 1},
                                undoable: true,
                            });
                            redirect('list', 'billing');
                        },
                    }}
                    type="button"
                />
            </Fragment>
        </Toolbar>
    );
};

export default BillingEditToolbar;
